import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

// Templates
import { LayoutDefault } from '@templates';

// Components
import { MarginHome, Skeleton, DownloadButton } from '@components';
import useDashboardExport from '@hooks/useDashboardExport';
import useFeatures from '@hooks/useFeatures';
import { getPreviousDate, getDateNowServer } from '@utils';

// Actions
import { actions as dashboardActions } from '@store/ducks/dashboard';
import { actions as groupActions } from '@store/ducks/group';
import { actions as userActions } from '@store/ducks/user';

// Containers
import {
  InitialInstructions,
  Summary,
  ChartStudyHours,
  ChartAccessFrequency,
  ChartCompletedSteps,
  Achievement,
  StudyHours,
  MostAccessedContent,
  ConsolidatedReport,
} from './containers';

// Styles
import { ContainerTables, WelcomeText, ExportAllContainer } from './Styled';

const Dashboard = () => {
  const dispatch = useDispatch();
  const { exportAll } = useDashboardExport();
  const features = useFeatures();
  useEffect(() => {
    // FILTER GROUP
    dispatch(userActions.getAllUsersRequest());
    dispatch(groupActions.getAllGroupsRequest());
    // DASHBOARD - WIDGETS
    dispatch(dashboardActions.getDashWidgetsRequest());
    // DASHBOARD - TABLES
    dispatch(dashboardActions.getDashAchievementRequest());
    dispatch(dashboardActions.getDashStudyHoursRequest());
    dispatch(dashboardActions.getDashMostAccessedContentRequest());
  }, []);

  const userReducer = useSelector((state) => state.user);

  const stepUserCompleted = !!(userReducer?.users?.length > 0);

  const handleExportAll = () =>
    exportAll({
      date_start: getPreviousDate(7),
      date_end: getDateNowServer(),
    });

  return (
    <LayoutDefault>
      {Array.isArray(userReducer?.users) ? (
        <>
          <WelcomeText>
            <span>
              <b>Bem vindo ao</b> Wise Up Corporate
            </span>
            <p>Acompanhe o dia a dia de progresso dos seus colaboradores.</p>
          </WelcomeText>
          {stepUserCompleted && (
            <ExportAllContainer>
              <DownloadButton
                label="Baixar todos os relatórios"
                onDownload={handleExportAll}
                variant="outlined"
              />
            </ExportAllContainer>
          )}
          <MarginHome top={36} />
          {!stepUserCompleted && <InitialInstructions />}
          {stepUserCompleted && features.consolidated_export && (
            <>
              <ConsolidatedReport />
              <MarginHome top={36} />
            </>
          )}
          <Summary />
          <MarginHome top={36} />
          <ChartStudyHours />
          <MarginHome top={36} />
          {stepUserCompleted && (
            <>
              <ChartAccessFrequency />
              <MarginHome top={36} />
              <ChartCompletedSteps />
              <MarginHome top={36} />
              <ContainerTables>
                <Achievement />
                <StudyHours />
              </ContainerTables>
              <MarginHome top={36} />
              <MostAccessedContent />
            </>
          )}
        </>
      ) : (
        <Skeleton width="100%" height="100%" />
      )}
    </LayoutDefault>
  );
};

export default Dashboard;
export { Dashboard };
